import PropTypes from "prop-types";
import React, { Component } from "react";
import { MSpinner, MSelect, MDialog } from "components/Shared";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { InputField, normalizeIntegerLength } from "components/FormElements";
import CaseAction from "components/Homeowner/CaseForms/Actions/CaseAction";
import { TimeLogList } from "components/Homeowner/CaseDetails";
import { getCaseConversionOptions, convertCaseSurveyType } from "actions/homeowner/casedetails";
import { getCustomerList, getActiveSurveyTypesByCustomer, getEnabledFeatures } from "requests/customer";
import { submitCaseToQA, cancelCase, validateForms, getCaseForms } from "actions/homeowner/caseforms";
import { withRouter } from "tools/routerCompat";
import CaseEmail from "components/Homeowner/CaseActions/CaseEmail";
import { sendCustomerEmail, getCustomerServiceEmail } from "requests/homeowner/caseEmail";
import { NEW_LENDER, EXISTING_LENDER } from "typeConstants/customerTypes";
import { insuranceReasonOptions, valuationReasonOptions } from "typeConstants/customerService";
import validator from "components/Shared/MGridFormDefinitions/validator";
import { DATA_TYPE_DROPDOWN } from "typeConstants/dataTypes";
import { getAttachments } from "requests/homeowner/caseforms";
import {
  CONVERT_CASE,
  SUBMIT_CASE_QA,
  CASE_DUPLICATE,
  CASE_DUPLICATE_WITH_ACCOUNT_SURVEY_TYPE,
  CASE_VALIDATION_VIEW, CASE_EMAIL_SEND,
  CASE_EMAIL_FROM_EDIT, CUSTOMER_SERVICE_EMAIL_SEND,
  COLLATERAL_ANALYTICS_RISK_PROFILER,
  SEND_MUELLER_HOME_LINK,
  FIELD_SCHEDULING_MANAGE,
  CASE_DUPLICATE_FOR_CUSTOMER,
  SCHEDULING_QUEUE_CASE_MOVE_TO_TOP,
  INSPECTION_QUEUE_CASE_MOVE_TO_TOP,
  APPRAISAL_QUEUE_CASE_MOVE_TO_TOP,
  CASE_EMAIL_SEND_UW_PERMISSION_TO_CLOSE,
  CASE_EMAIL_SEND_UW_PERMISSION_TO_EXTEND,
  CAN_REJECT_CASES,
  QA_CASE_INFO_VIEW,
  CASE_ISSUES_EDIT,
} from "typeConstants/rights";
import { addCaseTimeLog } from "actions/casetimelog";
import responseHandler from "responseHandler";
import { submitRiskProfilerResults, getRiskProfilerResults } from "requests/collateralAnalytics";
import { PrimaryStatus, SecondaryStatus} from "typeConstants/caseStatusCodes";
import { isAppraisalCase } from "components/Shared/Functions";
import {
  COLLATERAL_ANALYTICS_RISK_PROFILER as COLLATERAL_ANALYTICS_RISK_PROFILER_FEATURE,
  HIDE_REORDERLINK as HIDE_REORDERLINK_FEATURE,
  UW_PERMISSION_TO_EXTEND_DISABLE as UW_PERMISSION_TO_EXTEND_DISABLE_FEATURE
} from "typeConstants/customerFeatures";
import { moveToTopOfSchedulingQueue, moveToScheduling } from "requests/schedulingAssistant";
import { moveToTopOfInspectionQueue, moveToTopOfAppraisalQueue, getQaCaseInfo } from "requests/qualityAssurance/index.ts";
import { getQueueEntries } from "requests/queueEntries";
import CaseDuplicateFromState from "components/Homeowner/CaseForms/Actions/CaseDuplicateFromState.tsx";
import { userHasRight, userHasAnyRight } from "selectors/rights";
import UWPermissionToClose from "components/Homeowner/CaseActions/UWPermissionToClose.tsx";
import { isInPermissionToCloseWorkflow, cancelPermissionToClose } from "requests/closeOut/index.tsx";
import CaseIssues from "components/QualityAssurance/Sections/CaseDetails/CaseIssues/CaseIssues";
import { returnCase } from 'actions/qualityAssurance/';
import { AddIncidentFromCustomer } from "components/CustomerService";
import UWPermissionToExtend from "components/Homeowner/CaseActions/UWPermissionToExtend.tsx";
import { withPhoenixForms } from "components/PhoenixFormsV4/index.tsx";
import { isInPermissionToExtendWorkflow, cancelPermissionToExtend } from "requests/dueDateExtend/index.tsx";
import MuellerAtHomeInvite from "components/Homeowner/CaseActions/MuellerAtHomeInvite.tsx";
import { queueTypeCodes, queueTypeIds } from "typeConstants/employeeCustomerSurveyTypes/index.ts";

const queueTypeMap = {
  [queueTypeCodes.HOMEOWNERS_QA]: { label: "Move To Top (Inspection)", function: moveToTopOfInspectionQueue },
  [queueTypeCodes.APPRAISAL_QA]: { label: "Move To Top (Appraisal)", function: moveToTopOfAppraisalQueue },
  [queueTypeCodes.FIELD_APPOINTMENT]: { label: "Move To Top (Scheduling)", function: moveToTopOfSchedulingQueue },
};

const canEmail = (props) => props.canEmailCaseGeneral || props.canEmailUWPermissionToClose || props.canEmailUWPermissionToExtend;


class Actions extends Component {
    constructor(props) {
    super(props);

    this.state = {
      timeLogDialogVisible: false,
      canEnterTimeLog: false,
      caseTimeLogMinutes: { value: "" },
      isErrorInCaseTimeLogMinutes: false,
      convertCaseDialogVisible: false,
      copyCaseDialogVisible: false,
      isAddingTimeLog: false,
      accountList: [],
      fetchingAccountList: true,
      cancelCaseDialogVisible: false,
      cancelComments: "",
      customerServiceEmail: "",
      caseFileAttachments: [],
      manualSubmitRiskProfiler: false,
      enabledFeatures: [],
      muellerAtHomeDialogVisible: false,
      muellerAtHomeStatus: null,
      muellerAtHomeRequestCubiCasa: false,
      muellerAtHomeRequestForms: [],
      muellerAtHomeRecipient: "",
      muellerAtHomeRequestInProgress: false,
      muellerAtHomeWarningBypassed: false,
      timeLogFeedback: { required: false, workTypeId: 5 },
      returnToInspectorDialogVisible: false,
      returnToInspectorComments: "",
      QAQueueTypes: [],
      movingTypeToTopOfQueue: null, // type that we are moving to the top of the queue ("Homeowners QA", "Appraisal QA", "Field Appointment")
      moveToSchedulingDialogVisible: false,
      convertToSurveyType: null,
      sendEmailDialogVisible: false,
      fetchingIsInPermissionToCloseWorkflow: true,
      isInPermissionToCloseWorkflow: false,
      fetchingIsInPermissionToExtendWorkflow: true,
      isInPermissionToExtendWorkflow: false,
      isMovingToScheduling: false,
      isFetchingQaCaseInfo: props.canReturnToInspector && props.canViewQaCaseInfo,
      qaCaseInfo: null,
    };

    this.showTimeLogDialog = this.showTimeLogDialog.bind(this);
    this.hideTimeLogDialog = this.hideTimeLogDialog.bind(this);
    this.saveTimeLog = this.saveTimeLog.bind(this);
    this.isTimeLogDialogVisible = this.isTimeLogDialogVisible.bind(this);
    this.checkError = this.checkError.bind(this);
    this.showConvertCaseDialog = this.showConvertCaseDialog.bind(this);
    this.hideConvertCaseDialog = this.hideConvertCaseDialog.bind(this);
    this.convertCase = this.convertCase.bind(this);
    this.sumbitToQA = this.sumbitToQA.bind(this);
    this.isCopyCaseDialogVisible = this.isCopyCaseDialogVisible.bind(this);
    this.showCopyCaseDialog = this.showCopyCaseDialog.bind(this);
    this.hideCopyCaseDialog = this.hideCopyCaseDialog.bind(this);
    this.navigateToCase = this.navigateToCase.bind(this);
    this.createDialogActions = this.createDialogActions.bind(this);
    this.getTimeLogAction = this.getTimeLogAction.bind(this);
    this.getConvertAction = this.getConvertAction.bind(this);
    this.getSubmitAction = this.getSubmitAction.bind(this);
    this.getDuplicateAction = this.getDuplicateAction.bind(this);
    this.getCancelAction = this.getCancelAction.bind(this);
    this.createActionButton = this.createActionButton.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
    this.hasActions = this.hasActions.bind(this);
    this.setCustomerServiceEmail = this.setCustomerServiceEmail.bind(this);
    this.getValidationStatus = this.getValidationStatus.bind(this);
    this.getCustomerServiceReasons = this.getCustomerServiceReasons.bind(this);
    this.setCaseFileAttachments = this.setCaseFileAttachments.bind(this);
    this.submitToRiskProfiler = this.submitToRiskProfiler.bind(this);
    this.submitRiskProfilerSuccess = this.submitRiskProfilerSuccess.bind(this);
    this.checkExpectedMinutes = this.checkExpectedMinutes.bind(this);
    this.onMoveToSchedulingClicked = this.onMoveToSchedulingClicked.bind(this);
    this.showMoveToSchedulingDialog = this.showMoveToSchedulingDialog.bind(this);
    this.hideMoveToSchedulingDialog = this.hideMoveToSchedulingDialog.bind(this);
    this.getMoveToSchedulingAction = this.getMoveToSchedulingAction.bind(this);
    this.getEmailAction = this.getEmailAction.bind(this);
    this.getUnderwriterPermissionToCloseEmail = this.getUnderwriterPermissionToCloseEmail.bind(this);
    this.fetchPermissionToCloseWorkflowStatus = this.fetchPermissionToCloseWorkflowStatus.bind(this);
    this.getCancelPermissionToCloseAction = this.getCancelPermissionToCloseAction.bind(this);
    this.cancelPermissionToCloseWorkflow = this.cancelPermissionToCloseWorkflow.bind(this);
    this.getUnderwriterPermissionToExtendEmail = this.getUnderwriterPermissionToExtendEmail.bind(this);
    this.fetchPermissionToExtendWorkflowStatus = this.fetchPermissionToExtendWorkflowStatus.bind(this);
    this.getCancelPermissionToExtendAction = this.getCancelPermissionToExtendAction.bind(this);
    this.cancelPermissionToExtendWorkflow = this.cancelPermissionToExtendWorkflow.bind(this);
    this.onConvertCase = this.onConvertCase.bind(this);

    this.caseTimeLogWorkTypes = [
      { value: 5, label: "Valuation" }
    ];
    this.mounted = { current: true };
  }

  componentDidMount() {
    const {
      currentAccount,
      canEmailCustomerService,
      controlNumber,
      openWithCustomerServiceEmail,
      refreshMethod,
      canMoveToTopOfQueue,
      canViewQaCaseInfo,
      makeToast,
      canReturnToInspector,
    } = this.props;
    const { customerServiceEmail, caseFileAttachments } = this.state;

    refreshMethod();

    getCustomerList((response) => {
      this.setState({ accountList: response, fetchingAccountList: false });
    }, this.mounted);

    if (canReturnToInspector) {
      if (canViewQaCaseInfo) {
        getQaCaseInfo(
          controlNumber,
          this.mounted,
          (response) => {
            this.setState({ qaCaseInfo: response, isFetchingQaCaseInfo: false });
          },
          () => {
            this.setState({ isFetchingQaCaseInfo: false });
          }
        );
      }
      else {
        makeToast("User needs QA Case Info View to use Return To Inspector feature", "warning");
      }
    }

    if (canEmailCustomerService && customerServiceEmail === "") {
      getCustomerServiceEmail(controlNumber, this.setCustomerServiceEmail, this.mounted);
    }



    if ((canEmail(this.props) || canEmailCustomerService) && caseFileAttachments.length === 0) {
      getAttachments(controlNumber, this.setCaseFileAttachments, this.mounted);
    }

    if (canEmailCustomerService && openWithCustomerServiceEmail) {
      this.props.openCaseActionTab(this.getCustomerServiceEmail(CUSTOMER_SERVICE_EMAIL_TAB_ID), "Email Customer Service", CUSTOMER_SERVICE_EMAIL_TAB_ID);
    }

    if (currentAccount.customerNumber) getEnabledFeatures(currentAccount.customerNumber, (response) => this.setState({ enabledFeatures: response.features }), this.mounted);

    this.checkExpectedMinutes(0, this.caseTimeLogWorkTypes.filter(s => s.label === "Valuation")[0].value);

    if (canMoveToTopOfQueue) {
      getQueueEntries(controlNumber, entries => this.setState({ QAQueueTypes: entries.map(e => e.queueTypeCode) }), this.mounted);
    }

    this.fetchPermissionToCloseWorkflowStatus();
    this.fetchPermissionToExtendWorkflowStatus();
  }

  componentWillUnmount() {
    this.mounted.current = false;
  }

  getValidationStatus(vStatus) {
    let { comparableValidationResult } = this.props;
    if (vStatus && vStatus.length) {
      return (
        <div>
          <h4>Validation Summary</h4>
          <ul>
            {vStatus.map(v => this.renderValidationStatus(v))}
            <li className={`validation-status-${comparableValidationResult.length ? "hasissues" : "noissues"}`}>
              {`Comparables with Comparable Search has ${comparableValidationResult.length} validation issue${comparableValidationResult.length === 1 ? "" : "s"}!`}
            </li>
          </ul>
          {!this.props.FLCview ? <hr /> : []}
        </div>
      );
    }
    return null;
  }

  renderValidationStatus(v) {
    let classStatus;
    switch (v.status) {
      case -1:
        return null;
      case 0:
        classStatus = "noissues";
        break;
      case 1:
        classStatus = "hasissues";
        break;
      case 2:
        classStatus = "doesnotexist";
        break;
      case 3:
        classStatus = "inprocess";
        break;
    }
    return (
      <li key={v.module} className={"validation-status-" + classStatus}>
        {v.name} {v.message}
      </li>
    );
  }

  isTimeLogDialogVisible() {
    return this.state.timeLogDialogVisible;
  }

  showTimeLogDialog() {
    this.setState({ timeLogDialogVisible: true });
    this.setState({ fetchingAppraisalTimeLogs: true });
  }

  hideTimeLogDialog() {
    this.setState({ timeLogDialogVisible: false });
    this.setState({ fetchingAppraisalTimeLogs: false });
  }

  saveTimeLog() {
    let minutes = document.getElementById("timeLog-minutes");
    let workDate = document.getElementById("timeLog-workdate");
    let workTypeId = document.getElementById("timeLog-worktype");

    // save the time
    let model = {
      controlIdNumber: this.props.controlNumber,
      internetUserId: 0, // figures it out in the service on this page
      workDate: workDate.value,
      workTypeId: workTypeId.value,
      timeMinutes: parseInt(minutes.value)
    };

    this.props.addCaseTimeLog(model, () => {
      this.props.refreshMethod();
      this.hideTimeLogDialog();
      this.setState({ isAddingTimeLog: false });
      this.checkExpectedMinutes(minutes.value, workTypeId.value);
    });
    this.setState({ isAddingTimeLog: true });
  }

  checkExpectedMinutes(minutes, workTypeId) {
    const { caseHeader } = this.props;
    let expectedMinutes = caseHeader.caseInfo?.appraisalSurveyInfo?.appraiserLogMinutesExpected ?? 0;
    let totalMinutes = Number(minutes) + caseHeader.caseInfo?.appraisalSurveyInfo?.appraiserLogMinutesTotal ?? 0;
    if(expectedMinutes && expectedMinutes < totalMinutes) {
      this.setState({timeLogFeedback: { required: true, workTypeId: workTypeId }});
    }
  }

  checkError(input) {
    this.setState({ caseTimeLogMinutes: { value: input } });
    if (!input || input.length === 0) {
      this.setState({ canEnterTimeLog: false });
      return false;
    }
    if (
      this.props.caseHeader.caseInfo?.appraisalSurveyInfo?.appraiserLogMinutesMaximum > input &&
      this.props.caseHeader.caseInfo?.appraisalSurveyInfo?.appraiserLogMinutesAvailable > input
    ) {
      this.setState({ canEnterTimeLog: true });
      this.setState({ isErrorInCaseTimeLogMinutes: false });
      return false;
    } else {
      this.setState({ canEnterTimeLog: false });
      this.setState({ isErrorInCaseTimeLogMinutes: true });
      return true;
    }
  }

  isConvertDialogVisible() {
    return this.state.convertCaseDialogVisible;
  }

  showConvertCaseDialog() {
    this.props.getCaseConversionOptions(this.props.controlNumber);
    this.setState({ convertCaseDialogVisible: true });
  }

  hideConvertCaseDialog() {
    this.setState({ convertCaseDialogVisible: false });
  }

  onConvertCase(controlNumber) {
    this.props.getCaseForms(controlNumber, this.props.phoenixFormsContext.reload);
  }

  convertCase() {
    let surveyTypeCode = this.state.convertToSurveyType?.value;
    if (!surveyTypeCode || surveyTypeCode === "") return;

    const { controlNumber } = this.props;
    this.props.convertCaseSurveyType(controlNumber, surveyTypeCode, this.onConvertCase);
    this.hideConvertCaseDialog();
    this.setState({ convertToSurveyType: null });
    this.props.refreshMethod();
  }

  canSubmit() {
    return this.props.canSubmitToQa && (this.props.caseIsInProgress || this.props.caseIsInDataStatus);
  }

  sumbitToQA() {
    const { controlNumber } = this.props;
    this.props.submitCaseToQA(controlNumber, this.props.getCaseForms, true);
  }

  isCopyCaseDialogVisible() {
    return this.state.copyCaseDialogVisible;
  }

  showCopyCaseDialog() {
    this.setState({ copyCaseDialogVisible: true });
  }

  hideCopyCaseDialog() {
    this.setState({ copyCaseDialogVisible: false });
  }

  navigateToCase(controlNumber) {
    this.props.updateControlNumber(controlNumber);
  }

  createDialogActions(onCancel, onConfirm, confirmLabel, confirmDisabled, cancelText) {
    let actions = [];
    actions.push(
      <Button
        key="cancel"
        variant="text"
        color="secondary"
        onClick={onCancel}
      >
        {cancelText || "Cancel"}
      </Button>
    );
    actions.push(
      <Button
        key="confirm"
        disabled={confirmDisabled}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    );
    return actions;
  }

  createActionButton(id, onClick, disabled, label) {
    return (
      <Button
        id={id}
        onClick={onClick}
        disabled={disabled}
      >
        {label}
      </Button>
    );
  }

  getTimeLogAction() {
    const { caseHeader, timeLogs } = this.props;
    const { canEnterTimeLog, isAddingTimeLog, caseTimeLogMinutes, isErrorInCaseTimeLogMinutes } = this.state;
    return (
      <span className={"case-action"}>
        {this.createActionButton("action-timelog", this.showTimeLogDialog, !caseHeader.caseInfo?.appraisalSurveyInfo || !caseHeader.caseInfo?.appraisalSurveyInfo?.canAppraiserAddTimeLog, "Add Time Log")}
        <MDialog
          id={"action-timelog-dialog"}
          visible={this.isTimeLogDialogVisible()}
          contentActions={this.createDialogActions(this.hideTimeLogDialog, this.saveTimeLog, "Save", !canEnterTimeLog || isAddingTimeLog)}
          title="Enter Time Log"
          width={800}
          focusOnMount={false}
        >
          <div style={{ float: "left", width: 350 }}>
            <div>
              <Field
                id="timeLog-minutes"
                name="timeLog-minutes"
                required
                component={InputField}
                type="text"
                normalize={normalizeIntegerLength(3)}
                hintText="Minutes"
                errorText="Invalid Entry"
                checkError={this.checkError}
                input={caseTimeLogMinutes}
                isError={isErrorInCaseTimeLogMinutes}
              />
            </div>
            <div>
              <TextField
                select
                variant="standard"
                id={"timeLog-worktype"}
                label="Work Type"
                defaultValue="5"
                className="md-full-width"
              >
                {this.caseTimeLogWorkTypes.map((item) => (
                  <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
              </TextField>
            </div>
            <div>
              <TextField
                variant="standard"
                id={"timeLog-workdate"}
                label="Date"
                value={new Date().toDateString()}
                disabled={true}
              />
            </div>
          </div>
          <div style={{ float: "right", width: 350 }}>
            <TimeLogList
              timeLogs={timeLogs}
              appraisalSurveyInfo={caseHeader.caseInfo?.appraisalSurveyInfo}
            />
          </div>
        </MDialog>
      </span>
    );
  }

  handleConvertSurveyTypeChange = value => this.setState({ convertToSurveyType: value});
  convertCaseDialogSelector = () => document.querySelector(".convert-case-dialog");

  getConvertAction() {
    const { canConvert, caseConversionOptions, currentInspectionType } = this.props;
    return (
      <span className={"case-action"}>
        {this.createActionButton("action-convert", this.showConvertCaseDialog, !canConvert, "Convert")}
        <MDialog
          id="convert-dialog"
          className={"convert-case-dialog"}
          visible={this.isConvertDialogVisible()}
          contentActions={this.createDialogActions(this.hideConvertCaseDialog, this.convertCase, "Convert", !canConvert)}
          title="Convert Case"
          focusOnMount={false}
          width={400}
          portal
        >
          {caseConversionOptions.length > 0 || <MSpinner />}
          {caseConversionOptions &&
            <>
              <div>
                Current Survey Type <br />
                {currentInspectionType.name}
              </div>
              <div>
                Convert to
          <MSelect
                  options={caseConversionOptions}
                  getMenuPortalTarget={this.convertCaseDialogSelector}
                  isClearable={false}
                  onChange={this.handleConvertSurveyTypeChange}
                /></div>
            </>}
        </MDialog>
      </span>);
  }

  getSubmitAction() {
    return (
      <span className={"case-action"}>
        {this.createActionButton("action-submit-qa", this.sumbitToQA, !this.canSubmit(), "Submit to QA")}
      </span>);
  }

  getDuplicateAction() {
    const { canDuplicate, controlNumber, canDuplicateWithAccountSurveyType, canDuplicateAsCustomer } = this.props;
    const { fetchingAccountList, accountList } = this.state;
    const hideReorder = this.state.enabledFeatures.map(s => s.feature).includes(HIDE_REORDERLINK_FEATURE);
    const copyEnabled = (canDuplicate || canDuplicateWithAccountSurveyType || canDuplicateAsCustomer) && !hideReorder;
    const isExternalUser = canDuplicateAsCustomer && !(canDuplicate || canDuplicateWithAccountSurveyType);

    return (
      <span className={"case-action"}>
        {this.createActionButton("action-copy", this.showCopyCaseDialog, !copyEnabled, `${isExternalUser ? "Re-Order" : "Duplicate"}`)}
        <MDialog
          id="copy-dialog"
          className="copy-case-dialog"
          visible={this.isCopyCaseDialogVisible()}
          onHide={this.hideCopyCaseDialog}
          title={`${isExternalUser ? "Re-Order" : "Duplicate"} Case`}
          width={400}
        >
          <CaseDuplicateFromState
            controlNumber={controlNumber}
            fetchingAccountList={fetchingAccountList}
            accountList={accountList}
            portalTargetClass={"copy-case-dialog"}
            onFinished={this.hideCopyCaseDialog}
          />
        </MDialog>
      </span>);
  }

  getCancelAction() {
    const { canCancel, controlNumber, surveyAddress, currentInspectionType } = this.props;
    const { cancelComments, cancelCaseDialogVisible } = this.state;
    let hideCancelCaseDialog = () => this.setState({ cancelCaseDialogVisible: false });
    let cancelCase = () => {
      this.props.cancelCase(controlNumber, cancelComments, () => {
        hideCancelCaseDialog();
        this.props.refreshMethod();
      });
    };

    let checkError = text => this.setState({ cancelComments: text });

    return (
      <span className={"case-action"}>
        {this.createActionButton("action-cancel", () => this.setState({ cancelCaseDialogVisible: true }), !canCancel, "Cancel")}
        <MDialog
          id="cancel-dialog"
          className="CancelCaseDialog"
          visible={cancelCaseDialogVisible}
          onHide={hideCancelCaseDialog}
          contentActions={this.createDialogActions(hideCancelCaseDialog, cancelCase, "Confirm", !cancelComments.trim(), "Back")}
          title="Cancel Case"
          width={400}
        >
          <p>Control # <b>{`${controlNumber}`}</b></p>
          <p>Survey Address <b>{`${surveyAddress.address1} ${surveyAddress.city}, ${surveyAddress.state} ${surveyAddress.zip}`}</b></p>
          <p>Survey Type <b>{`${currentInspectionType.name}`}</b></p>
          <Field
            id="cancel-comment"
            name="cancel-comment"
            required
            component={InputField}
            type="text"
            hintText="Comments"
            errorText="Comments are required"
            checkError={checkError}
            input={cancelComments}
            isError={!cancelComments.trim()}
          />
          <br />
        </MDialog>
      </span>);
  }

  getSendMuellerAtHomeAction() {
    return (
      <span className={"case-action"}>
       <MuellerAtHomeInvite controlNumber={this.props.controlNumber} />
      </span>);
  }

  setCustomerServiceEmail(response) {
    this.setState({ customerServiceEmail: response.email });
  }

  setCaseFileAttachments(response) {
    let attachments = response.attachedFiles;
    if (!this.props.caseIsCompleted && attachments.length) {
      attachments = attachments.filter(a => a.locationType == 2); // StorageLocationType.CaseAttachment
    }
    this.setState({ caseFileAttachments: attachments });
  }

  getCustomerServiceReasons() {
    const { customerType } = this.props;
    let reasonsList = insuranceReasonOptions;
    if (customerType === NEW_LENDER || customerType === EXISTING_LENDER) {
      reasonsList = valuationReasonOptions;
    }
    return [
      { dataType: DATA_TYPE_DROPDOWN, label: "Reason", source: "reasonTypeCode", dataTypeOptions: { options: reasonsList }, hasValidationError: validator.required }
    ];
  }

  hasActions() {
    const { caseHistory, FLCview, canConvert, canUserAddTimeLog, canDuplicate, canDuplicateWithAccountSurveyType, canDuplicateAsCustomer, canCancel, canSendMuellerAtHome, canReturnToInspector, canMoveToScheduling } = this.props;
    return (caseHistory.lenderNextActions && caseHistory.lenderNextActions.length)
      || (!FLCview || canConvert || this.canSubmit() || canUserAddTimeLog || canDuplicate || canDuplicateWithAccountSurveyType || canDuplicateAsCustomer || canCancel || canEmail(this.props) || canSendMuellerAtHome || canReturnToInspector || canMoveToScheduling);
  }

  getCustomerCaseEmail(id) {
    return (<CaseEmail
      key={"customer-case-email"}
      controlNumber={this.props.controlNumber}
      sendMethod={sendCustomerEmail}
      subject={`Mueller Reports Policy Number ${this.props.caseHeader?.policyInfo?.policyHolderInfo?.policyNumber}`}
      caseFileAttachments={this.state.caseFileAttachments}
      sentCallback={() => this.props.closeTab(id)}
      enabledFeatures={this.state.enabledFeatures}
      canEditEmailFrom={this.props.canEditEmailFrom}
    />);
  }

  getCustomerServiceEmail(id) {
    return (<AddIncidentFromCustomer
      controlIdNumber={this.props.controlNumber}
      onAfterSend={() => {
        this.props.closeTab(id);
        this.props.makeToast("Email Sent", "success");
      }}
    />);
  }

  getUnderwriterPermissionToCloseEmail(id) {
    return (
      <UWPermissionToClose
        key="uw-permission-to-close-email"
        controlIdNumber={this.props.controlNumber}
        sentCallback={() => {
          this.props.closeTab(id);
          this.fetchPermissionToCloseWorkflowStatus();
        }}
      />
    );
  }

  getUnderwriterPermissionToExtendEmail(id) {
    return (
      <UWPermissionToExtend
        key="uw-permission-to-extend-email"
        controlIdNumber={this.props.controlNumber}
        sentCallback={() => {
          this.props.closeTab(id);
          this.fetchPermissionToExtendWorkflowStatus();
        }}
      />
    );
  }

  submitToRiskProfiler() {
    const { controlNumber } = this.props;
    if (!controlNumber) return;
    this.setState({ manualSubmitRiskProfiler: true });
    submitRiskProfilerResults(controlNumber, this.submitRiskProfilerSuccess, this.mounted);
  }

  submitRiskProfilerSuccess(r) {
    const { makeToast, getRiskProfilerResults, controlNumber } = this.props;
    this.setState({ manualSubmitRiskProfiler: false });
    if (r) {
      getRiskProfilerResults(controlNumber, () => { }, () => makeToast("There was an error retrieving risk profiler results.", "error"), this.mounted);
      return makeToast("CA Risk Profiler submission successful.", "success");
      }
    return makeToast("CA Risk Profiler submission failed.", "error");
  }

  getReturnToInspectorAction() {
    const { controlNumber, makeToast, canViewQaCaseInfo, user, canEditCaseIssues } = this.props;
    const { returnToInspectorComments, returnToInspectorDialogVisible, qaCaseInfo } = this.state;
    let hideReturnToInspectorDialog = () => this.setState({ returnToInspectorDialogVisible: false });
    let returnToInspector = () => {
      const data = {
        ControlIdNumber: controlNumber,
        QaQueueId: null,
        QaQueueTypeId: this.state.qaCaseInfo?.caseInfo?.queueTypeId,
        RejectionNotes: returnToInspectorComments,
        SendCopyToManager: false,
        TimeLog: null,
        internetUserId: user?.internetUserId || 0,
        isCaseActionsRequest: true,
      };
      this.props.returnCase(data, (res) => {
        if (this.props.requestSuccessful) {
          hideReturnToInspectorDialog();
          this.props.refreshMethod();
        }
        else if (res.isInvalid) {
          const validationMessage = res.validationMessage ?? "Return to inspector was invalid.";
          this.props.makeToast(validationMessage, "error");
        }
      });
    };

    let checkError = text => this.setState({ returnToInspectorComments: text });

    return (
      <span className={"case-action"}>
        {this.createActionButton(
          "action-return-to-inspector",
          () => {
            const qaAgentId = qaCaseInfo?.caseInfo?.qaAgentInternetUserId;
            let showDialog = true;

            if (!qaCaseInfo?.caseInfo) {
              showDialog = false;
              makeToast("Unable to retrieve QA Case Info. Please try reloading case actions and then try again.", "error");
              //If this flops no reason to even check anything else
              return;
            }
            if (qaAgentId && qaAgentId !== this.props.user?.internetUserId) {
              showDialog = false;
              makeToast("Case cannot be returned to inspector while actively being worked on by a QA Agent. Please contact the QAM or QAD on the case to request a rejection", "error");
            }
            if (![queueTypeIds[queueTypeCodes.HOMEOWNERS_QA], queueTypeIds[queueTypeCodes.APPRAISAL_QA]].includes(qaCaseInfo.caseInfo.queueTypeId)) {
              showDialog = false;
              makeToast("Case cannot be returned to inspector when queue type is not Homeowners QA or Appraisal QA, or when case is in Audit QA", "error");
            }
            if (!canEditCaseIssues) {
              showDialog = false;
              makeToast("You do not have permission to edit case issues which is necessary to return the case to the inspector. Please submit a request for the necessary permissions.", "error");
            }

            if (!showDialog) {
              return;
            }
            else {
              this.setState({ returnToInspectorDialogVisible: showDialog });
            }
          },
          !canViewQaCaseInfo,
          "Return To Inspector"
          )}
        <MDialog
          id="return-to-inspector-dialog"
          className="ReturnToInspectorDialog"
          visible={returnToInspectorDialogVisible}
          onHide={hideReturnToInspectorDialog}
          contentActions={this.createDialogActions(hideReturnToInspectorDialog, returnToInspector, "Confirm", !returnToInspectorComments.trim(), "Back")}
          title="Return To Inspector"
          width={600}
        >
          <CaseIssues
            controlNumber={controlNumber}
          />
          <Field
            id="return-to-inspector-comment"
            name="return-to-inspector-comment"
            required
            component={InputField}
            type="text"
            hintText="Comments"
            errorText="Comments are required"
            checkError={checkError}
            input={returnToInspectorComments}
            isError={!returnToInspectorComments.trim()}
          />
          <br />
        </MDialog>
      </span>);
  }

  onMoveToTopClicked = (queueTypeCode, areYouSure = false) => {
    if (areYouSure) {
      this.clearMoveToTop();
      queueTypeMap[queueTypeCode].function(this.props.controlNumber, () => this.props.makeToast("Case successfully moved to the top", "success"), this.mounted);
    } else {
      this.setState({ movingTypeToTopOfQueue: queueTypeCode });
      this.context.dialog.showYesNo(null, "Are you sure you want to move this case to the top of the queue?", () => this.onMoveToTopClicked(queueTypeCode, true));
    }
  }

  clearMoveToTop = () => {
    this.setState({ movingTypeToTopOfQueue: null });
  }

  getMoveToTopOfQueueButtons = () => (
    <span className={"case-action"}>
      <MDialog
        id="global-mueller-dialog"
        visible={!!this.state.movingTypeToTopOfQueue}
        contentActions={this.createDialogActions(this.clearMoveToTop, () => this.onMoveToTopClicked(this.state.movingTypeToTopOfQueue, true), "Yes", false, "No")}
      >
        Are you sure you want to move this case to the top of the queue?
      </MDialog>
      {this.state.QAQueueTypes.map(q => {
        if (queueTypeMap[q]) {  // Audit QA queue does not exist in this mapping but can be returned in queue entries
          return (<Button key={queueTypeMap[q].label} id="manually-submit-risk-profiler"
          onClick={() => this.onMoveToTopClicked(q)}>
            {queueTypeMap[q].label}
        </Button>);
        }
      })}
    </span>
  );

  onMoveToSchedulingClicked() {
    const { makeToast, refreshMethod, controlNumber } = this.props;
    this.setState({ isMovingToScheduling: true });

    moveToScheduling(
      controlNumber,
      (response) => {
        this.hideMoveToSchedulingDialog();
        this.setState({ isMovingToScheduling: false });
        if (response.error) {
          makeToast(response.errorMessages.join(), "error");
        }
        else {
          makeToast("Case moved to scheduling", "success");
          refreshMethod();
        }
      },
      () => {
        this.hideMoveToSchedulingDialog();
        this.setState({ isMovingToScheduling: false });
      },
      this.mounted
    );
  }

  showMoveToSchedulingDialog() {
    this.setState({ moveToSchedulingDialogVisible: true });
  }

  hideMoveToSchedulingDialog() {
    this.setState({ moveToSchedulingDialogVisible: false });
  }

  getMoveToSchedulingAction() {
    const { canMoveToScheduling } = this.props;
    const { moveToSchedulingDialogVisible, isMovingToScheduling } = this.state;
    return (<span className={"case-action"}>
      {this.createActionButton("action-move-to-scheduling", this.showMoveToSchedulingDialog, !canMoveToScheduling, "Move to Scheduling")}
      <MDialog
        id="move-to-scheduling-dialog"
        className="move-to-scheduling-dialog"
        visible={moveToSchedulingDialogVisible}
        onHide={this.hideMoveToSchedulingDialog}
        contentActions={this.createDialogActions(this.hideMoveToSchedulingDialog, this.onMoveToSchedulingClicked, "Yes", isMovingToScheduling, "No")}
        title="Move to Scheduling"
      >
        Are you sure you want to move this case to scheduling?
      </MDialog>
    </span>);
  }

  getEmailAction() {
    const {
      caseIsCompleted,
      caseHeader,
      canEmailCaseGeneral,
      canEmailUWPermissionToClose,
      canEmailUWPermissionToExtend,
    } = this.props;
    const {
      sendEmailDialogVisible,
      isInPermissionToCloseWorkflow,
      isInPermissionToExtendWorkflow,
      enabledFeatures,
    } = this.state;
    const uwPermissionToExtendDisabledFeature = enabledFeatures.find(f => f.feature === UW_PERMISSION_TO_EXTEND_DISABLE_FEATURE);
    return (
      <>
        <MDialog
          id="send-email-dialog"
          className=""
          visible={sendEmailDialogVisible}
          title="Select Email Type"
          contentActions={[<Button key="cancel" variant="text" color="secondary" onClick={() => this.setState({sendEmailDialogVisible: false})}>Cancel</Button>]}
        >
          {canEmailCaseGeneral && <p>{this.createActionButton("email-general", () => {
            this.setState({ sendEmailDialogVisible: false });
            this.props.openCaseActionTab(this.getCustomerCaseEmail(CASE_EMAIL_TAB_ID), "Compose Email", CASE_EMAIL_TAB_ID);
            }, false, "General")}</p>
          }
          {!caseIsCompleted && !isInPermissionToCloseWorkflow && canEmailUWPermissionToClose &&
            <p>{this.createActionButton("email-uw-permission-close", () => {
              this.setState({ sendEmailDialogVisible: false });
              this.props.openCaseActionTab(this.getUnderwriterPermissionToCloseEmail(UW_PERMISSION_TO_CLOSE_TAB_ID), "UW Permission To Close", UW_PERMISSION_TO_CLOSE_TAB_ID);
              }, false, "UW Permission To Close")}</p>
          }
          {!caseIsCompleted && caseHeader.caseInfo?.appointmentDateTime && !isInPermissionToExtendWorkflow && canEmailUWPermissionToExtend && !uwPermissionToExtendDisabledFeature &&
            <p>{this.createActionButton("email-uw-permission-extend", () => {
              this.setState({ sendEmailDialogVisible: false });
              this.props.openCaseActionTab(this.getUnderwriterPermissionToExtendEmail(UW_PERMISSION_TO_EXTEND_TAB_ID), "UW Permission To Extend", UW_PERMISSION_TO_EXTEND_TAB_ID);
              }, false, "UW Permission To Extend")}</p>
          }
        </MDialog>
        <span className="case-action">
          <Button
            id="customer-case-email-button"
            onClick={() => this.setState({ sendEmailDialogVisible: true })}
          >
            Send Email
          </Button>
        </span>
      </>
    );
  }

  fetchPermissionToCloseWorkflowStatus() {
    const {
      controlNumber,
    } = this.props;

    this.setState({ fetchingIsInPermissionToCloseWorkflow: true });

    isInPermissionToCloseWorkflow(controlNumber,
      (isInWorkflow) => {
        this.setState({ fetchingIsInPermissionToCloseWorkflow: false, isInPermissionToCloseWorkflow: isInWorkflow });
      },
      () => {
        this.setState({ fetchingIsInPermissionToCloseWorkflow: false });
      },
      this.mounted
    );
  }

  getCancelPermissionToCloseAction() {
    return (<span className={"case-action"}>
      {this.createActionButton("action-cancel-close-workflow", this.cancelPermissionToCloseWorkflow, false, "Remove UW Close Workflow")}
    </span>);
  }

  cancelPermissionToCloseWorkflow() {
    const {
      controlNumber,
    } = this.props;

    this.setState({ fetchingIsInPermissionToCloseWorkflow: true });

    cancelPermissionToClose(controlNumber,
      () => {
        this.fetchPermissionToCloseWorkflowStatus();
      },
      () => {
        this.setState({ fetchingIsInPermissionToCloseWorkflow: false });
      },
      this.mounted
    );
  }

  fetchPermissionToExtendWorkflowStatus() {
    this.setState({ fetchingIsInPermissionToExtendWorkflow: true });
    isInPermissionToExtendWorkflow(this.props.controlNumber,
      (isInWorkflow) => {
        this.setState({ fetchingIsInPermissionToExtendWorkflow: false, isInPermissionToExtendWorkflow: isInWorkflow });
      },
      () => {
        this.setState({ fetchingIsInPermissionToExtendWorkflow: false });
      },
      this.mounted
    );
  }

  getCancelPermissionToExtendAction() {
    return (<span className={"case-action"}>
      {this.createActionButton("action-cancel-extend-workflow", this.cancelPermissionToExtendWorkflow, false, "Remove UW Extend Workflow")}
    </span>);
  }

  cancelPermissionToExtendWorkflow() {
    this.setState({ fetchingIsInPermissionToExtendWorkflow: true });
    cancelPermissionToExtend(this.props.controlNumber,
      () => {
        this.fetchPermissionToExtendWorkflowStatus();
      },
      () => {
        this.setState({ fetchingIsInPermissionToExtendWorkflow: false });
      },
      this.mounted
    );
  }

  render() {
    const {
      caseHistory,
      fetchingHeader,
      fetchingValidationStatus,
      controlNumber,
      validateForms,
      validationStatus,
      FLCview,
      canConvert,
      canDuplicate,
      canUserAddTimeLog,
      canCancel,
      showValidations,
      canEmailCustomerService,
      comparableValidationResult,
      refreshMethod,
      timeLogs,
      canSubmitToRiskProfiler,
      canSendMuellerAtHome,
      canReturnToInspector,
      canMoveToScheduling,
      canDuplicateWithAccountSurveyType,
      canDuplicateAsCustomer,
      canMoveToTopOfQueue,
      caseIsInProgress,
      caseIsCompleted,
    } = this.props;

    const {
      manualSubmitRiskProfiler,
      fetchingIsInPermissionToCloseWorkflow,
      isInPermissionToCloseWorkflow,
      fetchingIsInPermissionToExtendWorkflow,
      isInPermissionToExtendWorkflow,
      isFetchingQaCaseInfo,
    } = this.state;

    if (
      !caseHistory
      || fetchingHeader
      || fetchingValidationStatus
      || manualSubmitRiskProfiler
      || fetchingIsInPermissionToCloseWorkflow
      || fetchingIsInPermissionToExtendWorkflow
      || isFetchingQaCaseInfo
    ) {
      return <MSpinner />;
    }

    let currentStatus = caseHistory.appraisalCurrentStatus
      ? caseHistory.appraisalCurrentStatus.name
      : "Appraisal Status Not Available";

    // disable the Submit button until all the little form errors are cleared.
    let hasFormsErrors = !!comparableValidationResult.length; // validationStatus && validationStatus.length > 0 && validationStatus[0].status != 0;
    let hasQaRejections = false;
    const userCanDuplicate = canDuplicate || canDuplicateWithAccountSurveyType || canDuplicateAsCustomer;
    if (validationStatus && validationStatus.length > 0) {
      validationStatus.forEach(s => {
        // status = 1 means there are issues with this type of validation
        if (s.status != 0) {
          if (s.module === 0) {
            hasFormsErrors = true; // form errors are not resolved.
          } else if (s.module === 3) {
            hasQaRejections = true; // QA rejections are not resolved.
          }
          // we do not care about Veros issues, yet (module === 2)
        }
      });
    }
    let actionSectionHasContent = this.hasActions();

    return (
      <Card className="md-cell md-cell--12 case-header">
        <CardContent style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "var(--card-header-bg-color)" }}>
          <Typography variant="h6" sx={{ color: 'var(--card-header-font-color)' }}>Actions</Typography>
          <i
            className="md-icon material-icons"
            style={{ cursor: "pointer" }}
            title="Refresh Status"
            onClick={refreshMethod}
          >
            refresh
          </i>
        </CardContent>
        <CardContent>
          {!FLCview && showValidations && actionSectionHasContent && (
            <div className="md-text-field-container md-full-width">
              <div className="md-floating-label--disabled">
                Current Status
              </div>
              <div className="md-full-width">
                <strong>{currentStatus}</strong>
                <span style={{ color: "lightgray" }}>
                  {" "}
                  (
                  {caseHistory.appraisalCurrentStatus &&
                    caseHistory.appraisalCurrentStatus.id}
                  )
                </span>
              </div>
            </div>
          )}
          {!FLCview && showValidations ? <hr /> : []}
          {showValidations && this.getValidationStatus(validationStatus)}
          {this.hasActions() ? <h4>Take Action ...</h4> : null}
          {caseHistory.lenderNextActions &&
            caseHistory.lenderNextActions.map(a => (
              <CaseAction
                key={a.code}
                buttonText={a.buttonText}
                disabled={
                  a.showValidationStatus &&
                  (hasFormsErrors || hasQaRejections)
                }
                isAppraisal={isAppraisalCase(this.props.caseHeader)}
                controlNumber={controlNumber}
                validateForms={validateForms}
                workflow={isAppraisalCase(this.props.caseHeader) ? "Appraisal" : "fieldsurvey"}
                method={a.code}
                commentRequired={a.commentRequired}
                showValidationStatus={a.showValidationStatus}
                validationStatus={this.getValidationStatus(validationStatus)}
                refreshMethod={refreshMethod}
                canUserAddTimeLog={canUserAddTimeLog}
                timeLogs={timeLogs}
                timeLogFeedback={this.state.timeLogFeedback}
                showTimeLogDialog={this.showTimeLogDialog}
                scrollToAppraisalReviewCard={this.props.scrollToAppraisalReviewCard}
                buttonOptions={a.options}
              />
            ))}
          <div>
            {canUserAddTimeLog && this.getTimeLogAction()}
            {canConvert && this.getConvertAction()}
            {this.canSubmit() && this.getSubmitAction()}
            {userCanDuplicate && this.getDuplicateAction()}
            {canCancel && this.getCancelAction()}
            {canEmail(this.props) && this.getEmailAction()}
            {canEmailCustomerService && <span className={"case-action"}>
              <Button
                id="customer-service-email-button"
                onClick={() => this.props.openCaseActionTab(this.getCustomerServiceEmail(CUSTOMER_SERVICE_EMAIL_TAB_ID), "Email Customer Service", CUSTOMER_SERVICE_EMAIL_TAB_ID)}
              >
                Customer Service
              </Button>
            </span>}
            {/* Show Submit to Risk Profiler button if user has right, enabled feature, and is appraisal */}
            {canSubmitToRiskProfiler && isAppraisalCase(this.props.caseHeader) && this.state.enabledFeatures.map(s => s.feature).includes(COLLATERAL_ANALYTICS_RISK_PROFILER_FEATURE) &&
            <Button id="manually-submit-risk-profiler"
              onClick={this.submitToRiskProfiler}>
                CA Risk Profiler
              </Button>}
            {(canSendMuellerAtHome && caseIsInProgress) && this.getSendMuellerAtHomeAction()}
            {canReturnToInspector && this.getReturnToInspectorAction()}
            {canMoveToTopOfQueue && this.getMoveToTopOfQueueButtons()}
            {canMoveToScheduling && this.getMoveToSchedulingAction()}
            {!caseIsCompleted && isInPermissionToCloseWorkflow && this.getCancelPermissionToCloseAction()}
            {!caseIsCompleted && isInPermissionToExtendWorkflow && this.getCancelPermissionToExtendAction()}
          </div>
          {(!actionSectionHasContent) && <div>No actions are available at this time</div>}
        </CardContent>
      </Card>
    );
  }
}

Actions.propTypes = {
  caseHistory: PropTypes.object.isRequired,
  addCaseTimeLog: PropTypes.func.isRequired,
  timeLogs: PropTypes.array,
  caseHeader: PropTypes.object,
  controlNumber: PropTypes.number.isRequired,
  validateForms: PropTypes.func.isRequired,
  fetchingValidationStatus: PropTypes.bool.isRequired,
  validationStatus: PropTypes.array,
  refreshMethod: PropTypes.func.isRequired,
  FLCview: PropTypes.bool,
  currentInspectionType: PropTypes.object.isRequired, //Used to display the current survey type in the convert case dialog.
  getCaseConversionOptions: PropTypes.func.isRequired, //Gets the valid options for case conversion
  caseConversionOptions: PropTypes.array, //Here's those valid options
  convertCaseSurveyType: PropTypes.func, //Action to convert the case survey type, callback can be used to update case info after action
  canConvert: PropTypes.bool, //User has Convert Case right
  getCaseForms: PropTypes.func.isRequired, //Used in the callback of convertCaseSurveyType and submitCaseToQa so that the case info updates
  submitCaseToQA: PropTypes.func, //Action to submit case to QA, callback can be used to update case info after action
  canSubmitToQa: PropTypes.bool, //User has Submit Case QA right
  caseIsCompleted: PropTypes.bool,
  caseIsInProgress: PropTypes.bool,
  caseIsInDataStatus: PropTypes.bool,
  specialAttentionNotes: PropTypes.string, //Used to prepopulate the dialog for duplicating a case
  surveyAddress: PropTypes.object, //Used to in the copy case dialog for user reference
  canDuplicate: PropTypes.bool.isRequired, //User has Case Duplicate right
  updateControlNumber: PropTypes.func, //Used to update to display a newly copied case
  canUserAddTimeLog: PropTypes.bool,  //used to display the add time logs button
  currentAccount: PropTypes.object,
  canDuplicateWithAccountSurveyType: PropTypes.bool,
  canCancel: PropTypes.bool, //used to display cancel case button
  cancelCase: PropTypes.func, //function to cancel a case
  showValidations: PropTypes.bool, // User can view validation status of case
  canEmailCaseGeneral: PropTypes.bool, // User can use email case feature
  canEditEmailFrom: PropTypes.bool, // User can edit From address on case e-mail
  canEmailCustomerService: PropTypes.bool, // User can send an email to customer service
  customerType: PropTypes.string.isRequired, // Used to get the customer service call reasons
  openCaseActionTab: PropTypes.func,   // Function to be called when the user clicks an action that opens in a new tab
  closeTab: PropTypes.func,  // Tab control method that is called with a tab id to close the tab
  comparableValidationResult: PropTypes.array.isRequired, // Comparable Validation endpoint has changed and the result is not a part of caseforms
  openWithCustomerServiceEmail: PropTypes.bool, // Indicator for whether or not we should open the CS e-mail on mount
  fetchingHistory: PropTypes.bool.isRequired,
  fetchingHeader: PropTypes.bool.isRequired,
  canSubmitToRiskProfiler: PropTypes.bool,
  makeToast: PropTypes.func,
  getRiskProfilerResults: PropTypes.func,
  scrollToAppraisalReviewCard: PropTypes.func.isRequired, // Allows us to scroll to GAAR or Veros card and open it
  user: PropTypes.object,
  canSendMuellerAtHome: PropTypes.bool.isRequired,
  canReturnToInspector: PropTypes.bool, // used to display return to inspector button
  returnToInspector: PropTypes.func, // function to return a case to inspector
  canMoveToScheduling: PropTypes.bool,
  canDuplicateAsCustomer: PropTypes.bool, // User can duplicate the case with limited options
  canMoveToTopOfQueue: PropTypes.bool,  // User can move case to top of a queue
  returnCase: PropTypes.func, // Reject a case to an inspector
  phoenixFormsContext: PropTypes.object,
  canEmailUWPermissionToClose: PropTypes.bool,
  canEmailUWPermissionToExtend: PropTypes.bool,
  canRejectCases: PropTypes.bool,
  canViewQaCaseInfo: PropTypes.bool,
  canEditCaseIssues: PropTypes.bool,
  requestSuccessful: PropTypes.bool.isRequired, // QA redux request successful
};

Actions.defaultProps = {
  FLCview: false
};

const mapStateToProps = (state) => {
  return {
    currentAccount: state.caseForms.caseHeader.policyInfo.customerInfo,
    caseConversionOptions: state.caseDetails.caseConversionOptions,
    canConvert: userHasRight(CONVERT_CASE)(state),
    canSubmitToQa: userHasRight(SUBMIT_CASE_QA)(state),
    canDuplicateWithAccountSurveyType: userHasRight(CASE_DUPLICATE_WITH_ACCOUNT_SURVEY_TYPE)(state),
    caseIsInProgress: state.caseForms.caseHeader.caseInfo.primaryStatus === PrimaryStatus.OPEN &&
      (state.caseForms.caseHeader.caseInfo.webStatus === SecondaryStatus.PREASSIGNMENT || state.caseForms.caseHeader.caseInfo.webStatus === SecondaryStatus.RECEIVED),
    caseIsCompleted: state.caseForms.caseHeader.caseInfo.primaryStatus === PrimaryStatus.COMPLETED,
    caseIsInDataStatus: state.caseForms.caseHeader.caseInfo.webStatus === SecondaryStatus.AWAITING_DATA
      || state.caseForms.caseHeader.caseInfo.webStatus === SecondaryStatus.DATA_FAILED,
    canDuplicate: userHasRight(CASE_DUPLICATE)(state),
    surveyAddress: state.caseForms.caseHeader.policyInfo.surveyAddress,
    currentInspectionType: state.caseForms.caseHeader.caseInfo.currentInspectionType,
    specialAttentionNotes: state.caseForms.caseHeader.caseInfo.webNotes,
    canUserAddTimeLog: state.caseForms.caseHeader.canUserAddTimeLog,
    canCancel: state.caseForms.caseHeader.canCancelCase && !isAppraisalCase(state.caseForms.caseHeader),
    showValidations: userHasRight(CASE_VALIDATION_VIEW)(state),
    canEmailCaseGeneral: userHasRight(CASE_EMAIL_SEND)(state),
    canEmailUWPermissionToClose: userHasRight(CASE_EMAIL_SEND_UW_PERMISSION_TO_CLOSE)(state),
    canEmailUWPermissionToExtend: userHasRight(CASE_EMAIL_SEND_UW_PERMISSION_TO_EXTEND)(state),
    canEditEmailFrom: userHasRight(CASE_EMAIL_FROM_EDIT)(state),
    canEmailCustomerService: userHasRight(CUSTOMER_SERVICE_EMAIL_SEND)(state),
    customerType: state.caseForms.caseHeader.policyInfo.customerInfo.customerType,
    openWithCustomerServiceEmail: state.caseStepper.trackerActive && state.caseStepper.isClosed,
    fetchingHistory: state.caseForms.fetchingHistory,
    fetchingHeader: state.caseForms.fetchingHeader,
    caseHistory: state.caseForms.caseHistory,
    caseHeader: state.caseForms.caseHeader,
    timeLogs: state.caseTimeLog.timeLogs,
    fetchingValidationStatus: state.validation.fetchingValidationStatus,
    validationStatus: state.validation.validationStatus,
    canSubmitToRiskProfiler: userHasRight(COLLATERAL_ANALYTICS_RISK_PROFILER)(state),
    user: state.user.profile,
    canSendMuellerAtHome: userHasRight(SEND_MUELLER_HOME_LINK)(state),
    canReturnToInspector: userHasRight(CAN_REJECT_CASES)(state)
      && (state.caseForms.caseHeader.caseInfo.webStatus === SecondaryStatus.QA),
    canMoveToScheduling: userHasRight(FIELD_SCHEDULING_MANAGE)(state) && state.caseForms.caseHeader.caseInfo.webStatus === SecondaryStatus.UNASSIGNED,
    canDuplicateAsCustomer: userHasRight(CASE_DUPLICATE_FOR_CUSTOMER)(state),
    canMoveToTopOfQueue: userHasAnyRight(SCHEDULING_QUEUE_CASE_MOVE_TO_TOP, INSPECTION_QUEUE_CASE_MOVE_TO_TOP, APPRAISAL_QUEUE_CASE_MOVE_TO_TOP)(state),
    canViewQaCaseInfo: userHasRight(QA_CASE_INFO_VIEW)(state),
    canEditCaseIssues: userHasRight(CASE_ISSUES_EDIT)(state),
    requestSuccessful: state.qualityAssurance.requestSuccessful,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCaseConversionOptions(controlNumber) {
    dispatch(getCaseConversionOptions(controlNumber));
  },
  convertCaseSurveyType(id, surveyTypeCode, callback) {
    dispatch(convertCaseSurveyType(id, surveyTypeCode, callback));
  },
  submitCaseToQA(controlNumber, callback, isCaseActionRequest = false) {
    dispatch(submitCaseToQA(controlNumber, callback, isCaseActionRequest));
  },
  getCustomerList() {
    dispatch(getCustomerList());
  },
  getSurveyTypesByCustomer(accountNumber) {
    dispatch(getActiveSurveyTypesByCustomer(accountNumber));
  },
  cancelCase(controlIdNumber, comments, callback) {
    dispatch(cancelCase(controlIdNumber, comments, callback));
  },
  addCaseTimeLog(caseTimeLogModel, callback = null) {
    dispatch(addCaseTimeLog(caseTimeLogModel, true, callback));
  },
  validateForms(controlIdNumber, formId = null, callback = null) {
    dispatch(validateForms(controlIdNumber, formId, callback));
  },
  getCaseForms(controlNumber, callback) {
    dispatch(getCaseForms(controlNumber, callback));
  },
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  getRiskProfilerResults(controlNumber, successCallback, errorCallback, mounted) {
    dispatch(getRiskProfilerResults(controlNumber, successCallback, errorCallback, mounted));
  },
  returnCase(payload, callback) {
    dispatch(returnCase(payload, callback));
  },
});

export default withPhoenixForms(withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: "History"
})(Actions))));

export const CASE_EMAIL_TAB_ID = "CASE_EMAIL_TAB_ID";
export const CUSTOMER_SERVICE_EMAIL_TAB_ID = "CUSTOMER_SERVICE_EMAIL_TAB_ID";
export const UW_PERMISSION_TO_CLOSE_TAB_ID = "UW_PERMISSION_TO_CLOSE_TAB_ID";
export const UW_PERMISSION_TO_EXTEND_TAB_ID = "UW_PERMISSION_TO_EXTEND_TAB_ID";
